import { LoadState } from "../../constants/enums";
import {
  IRestrictedModule,
  ISubscriptionPlan,
  ISubscriptionPlanState,
  ISubscriptionPriorityList,
  IUserSubscription,
} from "./subscription.types";

export const initialSubscriptionPlan: ISubscriptionPlan = {
  subscription_plan_uuid: null,
  plan_name: null,
  description: null,
  period: 1,
  billing_cycle: null,
  trial_period: 0,
  trial_cycle: null,
  plan_json: {},
  currency: "DOLLARS",
  price: null,
  set_default: 0,
  status: "ACTIVE",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
  subscription_plan_features: [],
};

export const initialUserSubscription: IUserSubscription = {
  user_subscription_uuid: null,
  subscription_plan_uuid: null,
  user_uuid: null,
  validity: null,
  start_at: null,
  expired_at: null,
  status: "ACTIVE",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
};

export const initialSubscriptionPriorityList: ISubscriptionPriorityList = {
  priority_list_uuid: "",
  priority_number: null,
  reference_column_name: "",
  reference_column_uuid: "",
  module_name: "SUBSCRIPTION_PLAN_FEATURE",
  status: "ACTIVE",
};

export const initialRestrictedModule: IRestrictedModule = {
  subscription_restricted_module_uuid: null,
  subscription_plan_uuid: null,
  module_name: null,
  read: null,
  write: null,
  view: null,
  write_count_limit: null,
  status: "ACTIVE",
  created_by_uuid: null,
  created_by_name: null,
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: null,
};

export const initialSubscriptionPlanState: ISubscriptionPlanState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  subscriptionPlan: {
    data: initialSubscriptionPlan,
    loading: LoadState.NotLoaded,
    error: null,
  },
  userSubscriptionList: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  userSubscription: {
    data: initialUserSubscription,
    loading: LoadState.NotLoaded,
    error: null,
  },
  restrictedModule: {
    data: initialRestrictedModule,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
